import ResetPassword from "../../components/Auth/ResetPassword";
import Footer from "../../components/Layout/Footer";
import Navbar from "../../components/Layout/Navbar";
import PageMeta from "../../components/pagesHelmet/PageMeta";

export default function ResetPage() {
  return (
    <>
    <PageMeta title="Reset Password | U2LR URL Shortener" description="" noIndex />
        <Navbar />
        <div className="auth-page">
          <ResetPassword />
        </div>
        <Footer />
    </>
  );
}